import { QueryBuilder } from './query-builder';
import { RuleGroup } from './query-builder-utils';
import Tooltip from '@mui/material/Tooltip';

interface MemberRestrictionFieldsProps {
  ruleGroup: RuleGroup;
  onRuleGroupChange: (updatedGroup: RuleGroup) => void;
  disabled?: boolean;
  disabledTooltip?: string;
  description?: string;
}

export default function MemberRestrictionFields({
  ruleGroup,
  onRuleGroupChange,
  disabled = false,
  disabledTooltip = '',
  description,
}: MemberRestrictionFieldsProps) {
  return (
    <Tooltip arrow title={disabled ? disabledTooltip : ''}>
      <span>
        <QueryBuilder
          ruleGroup={ruleGroup}
          onRuleGroupChange={onRuleGroupChange}
          disabled={disabled}
          description={description}
        />
      </span>
    </Tooltip>
  );
}
